/**
 * 网络请求
 */
import api from '../../api'

// 获取员工列表
export const getDetail = params => {
  return api.getDetail(params).then(res => {
    return res.data || {}
  })
}
